import { useQuery } from '@tanstack/react-query'
import { getRandomAgent } from '../services/contentService'

// Claves para React Query
export const randomAgentKeys = {
  all: ['randomAgent'] as const,
  byEmbedId: (embedId: string, encriptedString?: string, agentId?: string | number) => {
    return [
      ...randomAgentKeys.all, 
      'embedId', 
      embedId, 
      encriptedString,
      'agentId',
      agentId
    ].filter(Boolean)
  },
}

// Hook para obtener un agente aleatorio
export const useRandomAgent = (
  embedId: string = "ap_5b0e9c7ad4312f86b2c4e9a103d7f5c8_qn5h0z2y",
  encriptedString?: string,
  agentId?: string | number
) => {
  const enabled = !!embedId
  const queryKey = randomAgentKeys.byEmbedId(embedId, encriptedString, agentId)

  console.log('=== useRandomAgent Debug ===')
  console.log('embedId', embedId)
  console.log('agentId', agentId)
  console.log('enabled', enabled)
  console.log('queryKey', queryKey)

  return useQuery({
    queryKey,
    queryFn: () => {
      console.log('queryFn executing for random agent with embedId:', embedId, 'agentId:', agentId)
      return getRandomAgent(embedId, encriptedString, agentId)
    },
    enabled,
    staleTime: 30 * 1000, // 30 segundos de cache
    gcTime: 5 * 60 * 1000, // 5 minutos en memoria
    retry: (failureCount, error: any) => {
      // No reintentar si es error de autenticación
      if (error?.response?.status === 401) {
        return false
      }
      return failureCount < 3
    },
    refetchOnWindowFocus: false,
  })
}

export default useRandomAgent

